import { actionTypes } from '../common/constants/actionTypes';

import VttFooter from '../api/footerEntity';

export const footerReducer = (state: any, action: any) => {
  switch (action.type) {
      case actionTypes.FETCH_FOOTER_COMPLETED:
        const resultObjectClicked = handleFetchFooterCompleted(state, action.payload);
        return resultObjectClicked;
  }

  if (state) {
    return state;
  }

  return new VttFooter();
};

const handleFetchFooterCompleted: (state: any, payload: VttFooter) => any =
function handleItems(state: any, payload: VttFooter): any {
  return payload;
};


// WEBPACK FOOTER //
// ./src/reducers/footer.ts